import React, { useEffect, type FC } from 'react';

import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';

import { ObjectCommentContainer } from './ObjectCommentContainer.tsx';

type CommentTypes = {
	showGeneralComment?: boolean;
	pageWidthType?: string;
	showLabels: boolean;
	hasReactions: boolean;
	editorIsUserOffline?: boolean;
};

const ObjectCommentWrapperContent: FC<CommentTypes> = ({
	showGeneralComment,
	pageWidthType,
	showLabels,
	hasReactions,
	editorIsUserOffline,
}) => {
	const { setShowGeneralComments } = useCommentsPanelActions();

	useEffect(() => {
		setShowGeneralComments(showGeneralComment);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
	}, []);

	return (
		<ObjectCommentContainer
			pageWidthType={pageWidthType}
			showLabels={showLabels}
			hasReactions={hasReactions}
			editorIsUserOffline={editorIsUserOffline}
		/>
	);
};

export const ObjectCommentWrapper: FC<CommentTypes> = (props) => {
	if (!expValEquals('reduce_queries_in_default_suspense', 'isEnabled', true)) {
		return <ObjectCommentWrapperContent {...props} />;
	}

	return (
		<SuspenseWithDataFetcher dataFetcherName="object-comments">
			<ObjectCommentWrapperContent {...props} />
		</SuspenseWithDataFetcher>
	);
};
